export class PendingTaskCounter {
  private pendingCount = 0;
  private idleResolvers: Array<() => void> = [];

  get count(): number {
    return this.pendingCount;
  }

  start(): () => void {
    this.pendingCount++;
    let completed = false;

    return () => {
      if (completed) return;

      completed = true;
      this.pendingCount = Math.max(this.pendingCount - 1, 0);
      this.resolveWhenIdle();
    };
  }

  whenIdle(): Promise<void> {
    if (!this.pendingCount) return Promise.resolve();

    return new Promise((resolve) => this.idleResolvers.push(resolve));
  }

  clear(): void {
    this.pendingCount = 0;
    this.resolveWhenIdle();
  }

  private resolveWhenIdle(): void {
    if (this.pendingCount) return;

    const resolvers = this.idleResolvers;
    this.idleResolvers = [];
    resolvers.forEach((resolve) => resolve());
  }
}
